import { STATE_NAME, REVIEW_STORE_ORDER_TRANSITION } from './transition.offer.wizard.constants';
import { MetadataActions, MetadataConstants, MetadataSelectors } from 'invision-core';
import { TransitionIsAllowedSelector } from '../../../../reducers/selectors/transition.offer.wizard.selectors';
export function routing($stateProvider) {
  $stateProvider.state(STATE_NAME, {
    url: '/offering/:offeringId/offeringInstance/:offeringInstanceId/transition',
    ignoreBack: true,
    template: '<transition-offer class="u-sizeFull u-flexKeepHeight"></transition-offer>',
    resolve: {
      offerIdIsValid: function offerIdIsValid($q, $stateParams) {
        var offerId = $stateParams.offeringId;
        if (offerId !== undefined && offerId.trim().length && !isNaN(offerId)) {
          return $q.resolve();
        } else {
          return $q.reject({
            redirectTo: 'index.customercare.customer.dashboard',
            toParams: {
              customerId: $stateParams.customerId
            }
          });
        }
      },
      trasitionIsAllowed: function trasitionIsAllowed($q, $ngRedux, $stateParams) {
        return retrieveTransitionConfiguration($ngRedux.dispatch, $ngRedux.getState(), $q).then(function () {
          if (TransitionIsAllowedSelector($ngRedux.getState())) {
            return $q.resolve();
          } else {
            return $q.reject({
              redirectTo: 'index.customercare.customer.dashboard',
              toParams: {
                customerId: $stateParams.customerId
              }
            });
          }
        });
      }
    }
  }).state(REVIEW_STORE_ORDER_TRANSITION, {
    url: '/offering/:offeringId/offeringInstance/:offeringInstanceId/transition',
    ignoreBack: true,
    template: '<transition-offer class="u-sizeFull u-flexKeepHeight"></transition-offer>'
  });
  var retrieveTransitionConfiguration = function retrieveTransitionConfiguration(dispatch, state, $q) {
    if (!MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.TransitionConfiguration, state)) {
      return MetadataActions.codes.fetchCodeTypesPromise(dispatch, MetadataConstants.codes.TransitionConfiguration);
    } else {
      return $q.resolve();
    }
  };
}